export class VendorAccountParametersDto {
    vendorAccountId: number; // NOTE: Required for most endpoints except for vendor account editor and saving in add mode
    associationVendorId: number; // NOTE: required for all endpoints
    communityId: number;

    getQueryString(): string {
        if (this.vendorAccountId) {
            return `?vendorAccountId=${this.vendorAccountId}&associationVendorId=${this.associationVendorId}&communityId=${this.communityId}`;
        } else {
            return `?associationVendorId=${this.associationVendorId}&communityId=${this.communityId}`;
        }
    }
}
